<script>
export default {
  name: "RefundDialog",
  props: ["visible", "maxRefund"],
  methods: {
    close() {
      this.$emit("close");
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        this.$emit("save", {
          refundAmount: this.refundAmount,
          reason: this.reason,
        });
      }
    },
  },
  data() {
    return {
      refundAmount: 0,
      reason: "",
      requiredRule: value => !!value || "To pole jest wymagane", // Reguła walidacji
      maxRefundRule: value =>
          value <= this.maxRefund || `Kwota zwrotu nie może przekroczyć ${this.maxRefund} zł!`,
      minRefundRule: value =>
          value > 0 || "Kwota zwrotu musi być większa niż 0 zł!",


    };
  },
  watch: {
    maxRefund: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refundAmount = this.maxRefund; // Ustawienie domyślnej wartości
        }
      },
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="400">
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="close()" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Zwrot PayU</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                    label="Kwota zwrotu"
                    v-model.number="refundAmount"
                    step="0.01"
                    type="number"
                    :max="maxRefund"
                    :min="1"
                    :rules="[requiredRule,maxRefundRule,minRefundRule]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    label="Powód zwrotu"
                    v-model="reason"
                    :rules="[requiredRule]"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn color="primary" @click="submitForm">Zatwierdź</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>